export const HERO_NAME = "Dmytro Voloshyn";
export const TYPING_SPEED = 80;

export const QUICK_STATS = [
  { value: "17+", label: "Years Experience", color: "text-blue-400" },
  { value: "100+", label: "Developers Managed", color: "text-purple-400" },
  { value: "9", label: "Companies", color: "text-pink-400" },
  { value: "2019", label: "Best Travel Project", color: "text-green-400" },
];

export const SOCIAL_LINKS = [
  {
    href: "https://github.com/voloshyndmitry",
    label: "GitHub",
    delay: 2.2,
  },
  {
    href: "https://linkedin.com/in/voloshynd",
    label: "LinkedIn",
    delay: 2.3,
  },
  {
    href: "mailto:woloshindima@gmail.com",
    label: "Email",
    delay: 2.4,
  },
];
